<template>
  <div class="flex min-w-0 flex-1 flex-col justify-center">
    <BreadcrumbBar
      v-if="crumbs.length > 0"
      :crumbs="crumbs"
      unified
      class="text-xs leading-4 text-gray-500"
    />
    <div class="flex min-w-0 items-center gap-2">
      <h1 class="truncate font-artex text-xl leading-6 text-gray-800">
        {{ title }}
      </h1>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import BreadcrumbBar, {
  type BreadcrumbItem,
} from "@/components/Core/BreadcrumbBar.vue";

defineProps({
  title: { type: String, required: true },
  crumbs: { type: Array as PropType<BreadcrumbItem[]>, required: true },
});
</script>
